import React, { useState, useEffect, useRef } from "react";
import { saveAs } from "file-saver";
import ReactDOM from "react-dom";
import {
  Alert,
  Col,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Popover,
  PopoverBody,
  PopoverHeader,
  Row,
  Table,
} from "reactstrap";
import CurrentPiechart from "./Components/CurrentPiechart";
import MaturityModelProgressBar from "./Components/MaturityModelProgressbar";
import { Input, Collapse, Button } from "reactstrap";
import { deepClone } from "../../utils/copyObject";
import {
  maturity_model_questions_cats_wise,
  YES_NO_TYPE,
  WEEKS_TYPE,
} from "./data";
import { find, findIndex, groupBy } from "lodash";
import officeCreatedIcon from "../../assets/office_created_icon.svg";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import * as url from "../../utils/url";
import { IoCalendarClear } from "react-icons/io5";
import axios from "../../axios";
import { toastContainer } from "../../utils/toast";
import { connect } from "react-redux";
import Loading from "../../hoc/Loading/Loading";
import Select from "react-select";
import { FaCaretDown } from "react-icons/fa";
import * as actionCreators from "../../modules/actions";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { BsDownload, BsFillGearFill } from "react-icons/bs";
import { IoMenu } from "react-icons/io5";

import { CANVAS_PROXY_IMAGE_URL, formatDate } from "../../utils/constants";
import badge1Img from "../../assets/badge1.png";
import badge2025Img from "../../assets/mmBadge2025.png"
import { findDOMNode } from "react-dom";
import UpgradeModal from "./Components/UpgradeModal";

function CurrentTab({
  selectedDate,
  updateSelectedDate,
  user,
  isExternalUserLoggedIn,
  externalUserLoginDetails,
  updateExternalUserLogin,
}) {
  const [reportDoc, setReportDoc] = useState(null);

  const [sDate, setSDate] = useState(null);

  const snapShotRef = useRef();

  const [upgradeModalOpen, setUpgradeModalOpen] = useState(false);

  const badgeRef = useRef();

  const [totalScore, setTotalScore] = useState(0);

  const [scoreLoaded, setScoreLoaded] = useState(false);

  const [lastSubmittedToShow, setLastSubmittedToShow] = useState(null);

  const [strategyAndCommitmentData, setStrategyAndCommitmentData] = useState(
    null
  );

  const [questionsArray, setQuestionsArray] = useState([]);

  const [talentDiversityData, setTalentDiversityData] = useState(null);

  const [workplaceInclusivityData, setWorkplaceInclusivityData] = useState(
    null
  );

  const [benchmarksList, setBenchmarksList] = useState([]);

  const [industryOptions, setIndustryOptions] = useState([]);

  const [selectedIndustry, setSelectedIndustry] = useState(null);

  const [benchmarkModalOpen, setBenchmarkModalOpen] = useState(false);

  const [scoresThreshold, setScoresThreshhold] = useState({
    "STRATEGY & COMMITMENT": null,
    "TALENT DIVERSITY": null,
    "WORKPLACE INCLUSIVITY": null,
    "ENGAGEMENT & COMMUNICATION": null,
  });

  const isExternal =
    user && user.profile && user.profile.organizationId ? false : true;

  const groupQuestionsMapping =
    questionsArray && questionsArray.length
      ? groupBy(questionsArray, "group")
      : {
          "STRATEGY & COMMITMENT": [],
          "TALENT DIVERSITY": [],
          "WORKPLACE INCLUSIVITY": [],
          "ENGAGEMENT & COMMUNICATION": [],
        };

  const [groupWiseQuestions, setGroupWiseQuestions] = useState({
    display: false,
    data: [],
    title: "",
  });

  const [hoveredGroup, setHoveredGroup] = useState(null);

  const [
    engagementAndCommunicationData,
    setEngagementAndCommunicationData,
  ] = useState(null);

  useEffect(() => {
    getBenchmarkIndustryList();
  }, []);

  const availableBadge = moment(selectedDate).format("YYYY").toString() === "2025"? badge2025Img : badge1Img

  const getBenchmarkIndustryList = () => {
    axios.get(url.getMMBenchmarksData).then(({ data }) => {
      const urlParams = new URLSearchParams(window.location.search);
      const reportId = urlParams.get("reportId");
      const externalUserUniqueKey = urlParams.get("externalUserUniqueKey");
      if (isExternal && reportId && externalUserUniqueKey) {
        setScoreLoaded(false);
        axios
          .get(url.getReportByUserKey, {
            params: { reportId, externalUserUniqueKey },
          })
          .then(({ data }) => {
            setLastSubmittedToShow(null);
            setScoreLoaded(true);

            const scoreObj = data.data;

            updateExternalUserLogin({
              isExternalUserLoggedIn: true,
              externalUserLoginDetails: {
                email: scoreObj.externalUserData.email,
                password: scoreObj.externalUserData.password,
                companyName: scoreObj.externalUserData.companyName,
                industry: scoreObj.externalUserData.industry,
              },
            });

            updateSelectedDate(scoreObj.selectedDate);
            console.log(scoreObj);
            setQuestionsArray(data.data.surveyQuestions);
            if (scoreObj) {
              handleScoreObjSuccess(scoreObj);
            } else {
              toastContainer("No report found", "error");
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        handleDateChange(selectedDate);
      }
      const list = data.data.map((x) => ({ label: x.industry, value: x._id, isDeleted:x.isDeleted }));

      setBenchmarksList(deepClone(data.data));

      let newBenchmarksArr = []
      const grouped = groupBy(data.data,r => r.industry);

      for (const key in grouped) {
        if (Object.hasOwnProperty.call(grouped, key)) {
          const element = grouped[key];

          if(Array.isArray(element)){
            newBenchmarksArr.push(element[0])
          }
          
        }
      }
      setIndustryOptions(newBenchmarksArr.map((x) => ({
       label: x.industry,
       value: x._id,
       isDeleted: x.isDeleted,
     })))
    });
  };

  const getLastestDataForScore = (date) => {
    if (
      isExternal &&
      isExternalUserLoggedIn &&
      externalUserLoginDetails.email &&
      externalUserLoginDetails.password
    ) {
      axios
        .post(url.getExternalUserMMScores, {
          selectedDate: null,
          showDataBeforeDate: date,
          email: externalUserLoginDetails.email,
          password: externalUserLoginDetails.password,
        })
        .then(({ data }) => {
          const scoreObj = data.data.score;
          setQuestionsArray(data.data.data);
          if (scoreObj) {
            setLastSubmittedToShow(scoreObj.selectedDate);
            handleScoreObjSuccess(scoreObj);
          } else {
            // handleThreshhold(null)
            setReportDoc(null);
            setLastSubmittedToShow(null);
            setTotalScore(0);
            setEngagementAndCommunicationData({
              labels: ["Engagement & Communication", " "],
              values: [0, 100],
              title: "Engagement & Communication",
              colors: ["#FFCE56", "#ffffff"],
              kpis: [],
              gaugeValue: 0,
              gaugeColor: "#36A2EB",
            });
            setTalentDiversityData({
              labels: ["Talent Diversity", " "],
              values: [0, 100],
              title: "Talent Diversity",
              colors: ["#36A2EB", "#ffffff"],
              kpis: [],
              gaugeValue: 0,
              gaugeColor: "#36A2EB",
            });
            setWorkplaceInclusivityData({
              labels: ["Workplace Inclusivity", " "],
              values: [0, 100],
              title: "Workplace Inclusivity",
              colors: ["#FF6384", "#ffffff"],
              kpis: [],
              gaugeValue: 0,
              gaugeColor: "#FF6384",
            });
            setStrategyAndCommitmentData({
              labels: ["Strategy & Commitment", " "],
              values: [0, 100],
              title: "Strategy & Commitment",
              colors: ["#FF6384", "#ffffff"],
              kpis: [],
              gaugeValue: 0,
              gaugeColor: "#FF6384",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      axios
        .post(url.getScoreByDate, {
          selectedDate: null,
          showDataBeforeDate: date,
        })
        .then(({ data }) => {
          const scoreObj = data.data && data.data.score;
          if(data.data){
            setQuestionsArray(data.data.data);
          }

          setScoreLoaded(true)
        
          if (scoreObj) {
            setLastSubmittedToShow(scoreObj.selectedDate);
            handleScoreObjSuccess(scoreObj);
          } else {
            // handleThreshhold(null)
            setReportDoc(null);
            setLastSubmittedToShow(null);
            setTotalScore(0);
            // setEngagementAndCommunicationData({
            //   labels: ["Engagement & Communication", " "],
            //   values: [0, 100],
            //   title: "Engagement & Communication",
            //   colors: ["#FFCE56", "#ffffff"],
            //   kpis: [],
            //   gaugeValue: 0,
            //   gaugeColor: "#36A2EB",
            // });
            // setTalentDiversityData({
            //   labels: ["Talent Diversity", " "],
            //   values: [0, 100],
            //   title: "Talent Diversity",
            //   colors: ["#36A2EB", "#ffffff"],
            //   kpis: [],
            //   gaugeValue: 0,
            //   gaugeColor: "#36A2EB",
            // });
            // setWorkplaceInclusivityData({
            //   labels: ["Workplace Inclusivity", " "],
            //   values: [0, 100],
            //   title: "Workplace Inclusivity",
            //   colors: ["#FF6384", "#ffffff"],
            //   kpis: [],
            //   gaugeValue: 0,
            //   gaugeColor: "#FF6384",
            // });
            // setStrategyAndCommitmentData({
            //   labels: ["Strategy & Commitment", " "],
            //   values: [0, 100],
            //   title: "Strategy & Commitment",
            //   colors: ["#FF6384", "#ffffff"],
            //   kpis: [],
            //   gaugeValue: 0,
            //   gaugeColor: "#FF6384",
            // });
          }
        })
        .catch((err) => {
          console.log(err);
        });
      // axios
      // .post(url.getExternalUserMMScores, {
      //   selectedDate: null,
      //   showDataBeforeDate: date,
      // })
      // .then(({ data }) => {
      //   const scoreObj = data.data.score;
      //   setQuestionsArray(data.data.data);
      //   if (scoreObj) {
      //     setLastSubmittedToShow(scoreObj.selectedDate);
      //     handleScoreObjSuccess(scoreObj);
      //   } else {
      //     // handleThreshhold(null)
      //     setReportDoc(null);
      //     setLastSubmittedToShow(null);
      //     setTotalScore(0);
      //     setEngagementAndCommunicationData({
      //       labels: ["Engagement & Communication", " "],
      //       values: [0, 100],
      //       title: "Engagement & Communication",
      //       colors: ["#FFCE56", "#ffffff"],
      //       kpis: [],
      //       gaugeValue: 0,
      //       gaugeColor: "#36A2EB",
      //     });
      //     setTalentDiversityData({
      //       labels: ["Talent Diversity", " "],
      //       values: [0, 100],
      //       title: "Talent Diversity",
      //       colors: ["#36A2EB", "#ffffff"],
      //       kpis: [],
      //       gaugeValue: 0,
      //       gaugeColor: "#36A2EB",
      //     });
      //     setWorkplaceInclusivityData({
      //       labels: ["Workplace Inclusivity", " "],
      //       values: [0, 100],
      //       title: "Workplace Inclusivity",
      //       colors: ["#FF6384", "#ffffff"],
      //       kpis: [],
      //       gaugeValue: 0,
      //       gaugeColor: "#FF6384",
      //     });
      //     setStrategyAndCommitmentData({
      //       labels: ["Strategy & Commitment", " "],
      //       values: [0, 100],
      //       title: "Strategy & Commitment",
      //       colors: ["#FF6384", "#ffffff"],
      //       kpis: [],
      //       gaugeValue: 0,
      //       gaugeColor: "#FF6384",
      //     });
      //   }
      // })
      // .catch((err) => {
      //   console.log(err);
      // });
    }
  };

  useEffect(() => {
    if (reportDoc) {
      setSelectedIndustry(reportDoc.selectedBenchmarkId);
      handleThreshhold(reportDoc.selectedBenchmarkId);
    } else {
      handleThreshhold(null);
    }
  }, [reportDoc]);

  const handleDateChange = (d) => {
    setScoreLoaded(false);
    updateSelectedDate(d ? formatDate(d) : null);

    if (
      isExternal 
    ) {
      if(isExternalUserLoggedIn &&
        externalUserLoginDetails.email &&
        externalUserLoginDetails.password){
          axios
          .post(url.getExternalUserMMScores, {
            selectedDate: d ? formatDate(d) : null,
            email: externalUserLoginDetails.email,
            password: externalUserLoginDetails.password,
          })
          .then(({ data }) => {
            setLastSubmittedToShow(null);
            setScoreLoaded(true);
            const scoreObj = data.data.score;
            setQuestionsArray(data.data.data);
            if (scoreObj) {
              handleScoreObjSuccess(scoreObj);
            } else {
              getLastestDataForScore(formatDate(d));
            }
          })
          .catch((err) => {
            setScoreLoaded(true)
            console.log(err);
          });
        }else{
          setScoreLoaded(true)
        }
      
    } else {
      axios
        .post(url.getScoreByDate, {
          selectedDate: d ? formatDate(d) : null,
        })
        .then(({ data }) => {
          setLastSubmittedToShow(null);
        
          const scoreObj = data.data.score;
          setQuestionsArray(data.data.data);
          if (scoreObj) {
            setScoreLoaded(true);
            handleScoreObjSuccess(scoreObj);
          } else {
            getLastestDataForScore(formatDate(d));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleScoreObjSuccess = (scoreObj) => {
    if (!selectedDate) {
      updateSelectedDate(scoreObj.selectedDate);
    }

    setReportDoc(scoreObj);

    console.log("opoppopo", scoreObj);

    setTotalScore(Math.round(scoreObj.total_score / 1));

    const groupScoreSc = scoreObj.group_scores.find(
      (x) => x.name == "STRATEGY & COMMITMENT"
    );
    const groupScoreTd = scoreObj.group_scores.find(
      (x) => x.name == "TALENT DIVERSITY"
    );
    const groupScoreWi = scoreObj.group_scores.find(
      (x) => x.name == "WORKPLACE INCLUSIVITY"
    );
    const groupScoreEc = scoreObj.group_scores.find(
      (x) => x.name == "ENGAGEMENT & COMMUNICATION"
    );

    let guageColorSet = "#1A85FF";

    if (groupScoreSc) {
      setStrategyAndCommitmentData({
        labels: ["Strategy & Commitment", " "],
        values: [groupScoreSc.score, 100 - groupScoreSc.score],
        title: "Strategy & Commitment",
        colors: ["#FF6384", "#ffffff"],
        kpis: groupScoreSc.kpiScores.map((x) => x.type),
        gaugeValue: groupScoreSc.score,
        gaugeColor: guageColorSet,
      });
    }
    if (groupScoreTd) {
      setTalentDiversityData({
        labels: ["Talent Diversity", " "],
        values: [groupScoreTd.score, 100 - groupScoreTd.score],
        title: "Talent Diversity",
        colors: ["#36A2EB", "#ffffff"],
        kpis: groupScoreTd.kpiScores.map((x) => x.type),
        gaugeValue: groupScoreTd.score,
        gaugeColor: guageColorSet,
      });
    }
    if (groupScoreWi) {
      setWorkplaceInclusivityData({
        labels: ["Workplace Inclusivity", " "],
        values: [groupScoreWi.score, 100 - groupScoreWi.score],
        title: "Workplace Inclusivity",
        colors: ["#FF6384", "#ffffff"],
        kpis: groupScoreWi.kpiScores.map((x) => x.type),
        gaugeValue: groupScoreWi.score,
        gaugeColor: guageColorSet,
      });
    }
    if (groupScoreEc) {
      setEngagementAndCommunicationData({
        labels: ["Engagement & Communication", " "],
        values: [groupScoreEc.score, 100 - groupScoreEc.score],
        title: "Engagement & Communication",
        colors: ["#FFCE56", "#ffffff"],
        kpis: groupScoreEc.kpiScores.map((x) => x.type),
        gaugeValue: groupScoreEc.score,
        gaugeColor: guageColorSet,
      });
    }
  };

  const handleThreshhold = (id) => {
    const benchmarkDoc = benchmarksList.find((x) => x._id == id);

    if (benchmarkDoc) {
      const groupScoreSc =
        benchmarkDoc.group_scores.find(
          (x) => x.name == "STRATEGY & COMMITMENT"
        ) || {};
      const groupScoreTd =
        benchmarkDoc.group_scores.find((x) => x.name == "TALENT DIVERSITY") ||
        {};
      const groupScoreWi =
        benchmarkDoc.group_scores.find(
          (x) => x.name == "WORKPLACE INCLUSIVITY"
        ) || {};
      const groupScoreEc =
        benchmarkDoc.group_scores.find(
          (x) => x.name == "ENGAGEMENT & COMMUNICATION"
        ) || {};

      setScoresThreshhold({
        TOTAL: benchmarkDoc.total_score,
        "STRATEGY & COMMITMENT": groupScoreSc.score,
        "TALENT DIVERSITY": groupScoreTd.score,
        "WORKPLACE INCLUSIVITY": groupScoreWi.score,
        "ENGAGEMENT & COMMUNICATION": groupScoreEc.score,
      });
    } else {
      setScoresThreshhold({
        TOTAL: null,
        "STRATEGY & COMMITMENT": null,
        "TALENT DIVERSITY": null,
        "WORKPLACE INCLUSIVITY": null,
        "ENGAGEMENT & COMMUNICATION": null,
      });
    }
  };

  function findDocumentByIndustryAndYear(data, industry, year) {
    // Filter documents matching the given industry
    const matchingIndustryDocs = data.filter(doc => doc.industry === industry);

    if (matchingIndustryDocs.length === 0) {
        return null; // No documents found for the given industry
    }

    // Sort documents by year of selectedDate
    matchingIndustryDocs.sort((a, b) => {
        const yearA = new Date(a.selectedDate).getFullYear();
        const yearB = new Date(b.selectedDate).getFullYear();
        return yearA - yearB;
    });

    // Find the exact year match
    const exactMatch = matchingIndustryDocs.find(doc => {
        return new Date(doc.selectedDate).getFullYear() === year;
    });

    if (exactMatch) {
        return exactMatch;
    }

    // Find the nearest year document
    let nearestDoc = null;
    let minDiff = Infinity;

    for (const doc of matchingIndustryDocs) {
        const docYear = new Date(doc.selectedDate).getFullYear();
        const diff = Math.abs(docYear - year);

        if (diff < minDiff) {
            minDiff = diff;
            nearestDoc = doc;
        }
    }

    return nearestDoc;
}

  const handleIndustryChange = (item) => {
    if (item) {

      const mainItem = findDocumentByIndustryAndYear(benchmarksList,item.label,parseInt(moment(selectedDate).format("YYYY")))
      setBenchmarkModalOpen(false);
      setSelectedIndustry(item.value);

      axios
        .post(
          isExternal
            ? url.updateBenchmarkForReportExternal
            : url.updateBenchmarkForReport,
          {
            reportId: reportDoc ? reportDoc._id : null,
            benchmarkId: mainItem._id,
            selectedDate: selectedDate,
          }
        )
        .then(({ data }) => {
          setReportDoc(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setBenchmarkModalOpen(false);
      setSelectedIndustry(null);

      axios
        .post(url.updateBenchmarkForReport, {
          reportId: reportDoc ? reportDoc._id : null,
          benchmarkId: null,
        })
        .then(({ data }) => {
          setReportDoc(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handleDownload = async (option) => {
    if (option === "snapshot") {
      console.log("Downloading Snapshot...");
      // let node = findDOMNode(snapShotRef.current);
      // html2canvas(node, {
      //   useCORS: true,
      //   allowTaint: true,
      //   proxy: CANVAS_PROXY_IMAGE_URL,
      // }).then((canvas) => {
      //   canvas.toBlob((blob) => {
      //     let newWindow = window.open("/");
      //     newWindow.location = URL.createObjectURL(blob);
      //     let name = `Snapshot ${moment(selectedDate).format("MM/DD/YYY")}`;
      //     saveAs(blob, name);
      //   });
      // });
      const data = await document.querySelector("#jspdf_export_snapshot");

      const pdf = window.html2pdf().from(data);

      pdf.then(async () => {
        pdf.save(
          `${moment(new Date()).format(
            "dddd, MMMM Do YYYY, h:mm:ss a"
          )} - Snapshot.pdf`
        );

        // else {
        //   var string = await pdf.output("datauristring")
        //   console.log(string)
        //   var embed = "<embed width='100%' height='100%' src='" + string + "'/>";
        //   var x = window.open();
        //   x.document.open();
        //   x.document.write(embed);

        //   var a = document.createElement("A");
        //   var filePath = await pdf.output("datauristring");
        //   a.href = filePath;
        //   a.download = `${moment(new Date()).format(
        //     "dddd, MMMM Do YYYY, h:mm:ss a"
        //   )} - dani.pdf`;
        //   document.body.appendChild(a);
        //   setTimeout(() => {
        //     a.click();
        //     document.body.removeChild(a);
        //     x.close();
        //   }, 700);
        // }
      });
    } else if (option === "badge") {
      console.log("Downloading Badge...");

      let img = availableBadge;
      let name = "Aware";

      if (totalScore > 0 && totalScore <= 25) {
        img = null;
        name = "";
      } else if (totalScore >= 26 && totalScore <= 50) {
        img = availableBadge;
        name = "Aware";
      } else if (totalScore >= 51 && totalScore <= 75) {
        img = availableBadge;
        name = "Focused";
      } else if (totalScore >= 76 && totalScore <= 100) {
        img = availableBadge;
        name = "Progressive";
      }

      const link = document.createElement("a");
      link.href = img;

      // link.download = `Badge ${name}.png`; // Set the file name for the download
      link.download = `Badge ${moment(new Date()).format(
        "dddd, MMMM Do YYYY"
      )}.png`; // Set the file name for the download

      // Append the link to the body temporarily, trigger click, and remove the link
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      // Logic to download badge
    }
  };

  console.log({benchmarksList,selectedIndustry})
  const getBadgeImageBasedOnScore = () => {
    console.log("totalScore -- ", totalScore);
    if (totalScore > 0 && totalScore <= 25) {
      return { src: availableBadge, disabled: true };
    } else if (totalScore >= 26 && totalScore <= 50) {
      return { src: availableBadge, disabled: false };
    } else if (totalScore >= 51 && totalScore <= 75) {
      return { src: availableBadge, disabled: false };
    } else if (totalScore >= 76 && totalScore <= 100) {
      return { src: availableBadge, disabled: false };
    } else {
      return { src: availableBadge, disabled: true };
    }
  };

  const commonUi = () => {
    return (
      <div style={{ position: "relative" }}>
      
        <div className="mx-5" style={{ zIndex: 9 }}>
          <div className="d-flex justify-content-center my-4">
            <div
              className={`mm-current-badge-container ${
                getBadgeImageBasedOnScore().disabled ? "disabled" : ""
              }`}
            >
              <img style={{height:'100px'}} src={getBadgeImageBasedOnScore().src} />
            </div>
            <div className="ml-2 mm-snapshot-badge-container">
              <h6 className="mb-0 current_score_text">Current score: {parseInt(totalScore)}%</h6>{" "}
              {!isExternal && scoresThreshold["TOTAL"] ? (
                <span style={{  fontSize: "0.9rem" }}>
                  Benchmark: {scoresThreshold["TOTAL"]}%
                </span>
              ) : (
                ""
              )}
              <div
                className={`mm-snapshot-download-badge-container`}
                onClick={
                  totalScore > 25 ? () => handleDownload("badge") : null
                  // ()=>{
                  // if(getBadgeImageBasedOnScore().disabled){

                  // }else{
                  //   handleDownload("badge")
                  // }}
                }
              >
                {/* <Button size="sm" className="py-0 px-1" outline>
                    {" "}
                    <BsDownload size={17} />{" "}
                  </Button>{" "} */}
                <BsDownload
                  className={`mm-snapshot-badge-img ${
                    totalScore < 26 ? "disabled" : ""
                  }`}
                  size={18}
                />{" "}
                <span
                  className={`link-text`}
                  style={{ textDecoration: "none", fontSize: "0.8rem" }}
                >
                  {totalScore > 25
                    ? "Download badge"
                    : 'Become "Focused" to get badge'}
                </span>
              </div>
              {/* {
              // !getBadgeImageBasedOnScore().disabled ? 
              totalScore >26 ? 
              (
                <div className="mm-snapshot-download-badge-container" onClick={totalScore >26? ()=> handleDownload("badge"):null}>
                  <Button size="sm" className="py-0 px-1" outline>
                    {" "}
                    <BsDownload size={17} />{" "}
                  </Button>{" "}
                  <BsDownload className="mm-snapshot-badge-img" size={18} />{" "}
                  <span className="link-text" style={{textDecoration:"none", fontSize:'0.8rem'}}>Download badge</span>
                </div>
              ) : (
                ''
              )} */}
            </div>
          </div>

          <MaturityModelProgressBar
            labelImgData={[
              {
                text: "Aware",
                image: availableBadge,
                range: [1, 26],
                tooltipText:
                  "The organization​ is “Aware” of the benefits of Diversity, Equity and Inclusion (DEI) and is ready to focus on efforts to make improvements.",
              },
              {
                text: "Focused",
                image: availableBadge,
                range: [26, 51],
                tooltipText:
                  "The organization​ ​has already been Aware of the benefits of Diversity, Equity and Inclusion (DEI) and is now “Focused” on efforts to set goals, make improvements and start seeing benefits.",
              },
              {
                text: "Progressive",
                image: availableBadge,
                range: [51, 76],
                tooltipText:
                  "The ​organization has been focused on Diversity, Equity and Inclusion (DEI) and workplace culture for some time, and is most likely reaping  significant benefits in terms of business outcomes and employee experience.",
              },
              {
                text: "World Class",
                image: availableBadge,
                range: [76, 100],
                tooltipText:
                  "The organization​ ​has advanced beyond their internal Diversity, Equity and Inclusion (DEI) efforts and is already contributing, or about to contribute, to DEI across their industry and beyond with thought leadership and novel approaches.",
              },
            ]}
            value={totalScore}
            threshhold={scoresThreshold["TOTAL"]}
          />
        </div>
        {!strategyAndCommitmentData && isExternal ? (
          <div className="external_user_layover">
            <Alert
              style={{
                width: "max-content",
                backgroundColor: "#CCE5FE",
                color: "#004084",
              }}
              className="py-4 px-5"
            >
              Please answer Questions first to access
            </Alert>
          </div>
        ) : (
          ""
        )}
        <div className="mt-2">
          <Row className="mm_chart_container">
            <Col>
              <div>
                {groupQuestionsMapping["STRATEGY & COMMITMENT"] &&
                groupQuestionsMapping["STRATEGY & COMMITMENT"].length ? (
                  <div
                    className="link-text cursor-pointer see-questions-div"
                    onClick={() => {
                      setGroupWiseQuestions({
                        display: true,
                        data: groupQuestionsMapping["STRATEGY & COMMITMENT"],
                        title: strategyAndCommitmentData.title,
                      });
                    }}
                  >
                    See questions
                  </div>
                ) : (
                  ""
                )}
                {strategyAndCommitmentData ? (
                  <CurrentPiechart
                    labels={strategyAndCommitmentData.labels}
                    values={strategyAndCommitmentData.values}
                    title={strategyAndCommitmentData.title}
                    colors={strategyAndCommitmentData.colors}
                    kpis={strategyAndCommitmentData.kpis}
                    gaugeValue={strategyAndCommitmentData.gaugeValue}
                    gaugeColor={strategyAndCommitmentData.gaugeColor}
                    gaugeThreshhold={!isExternal ? scoresThreshold["STRATEGY & COMMITMENT"]:null}
                  />
                ): <CurrentPiechart
                gaugeValue={0}
                gaugeColor="white"
                title="Strategy & Commitment"
                isEmptyState
              />}
              </div>
            </Col>

            <Col>
              <div>
                {groupQuestionsMapping["TALENT DIVERSITY"] &&
                groupQuestionsMapping["TALENT DIVERSITY"].length ? (
                  <div
                    className="link-text cursor-pointer see-questions-div"
                    onClick={() => {
                      setGroupWiseQuestions({
                        display: true,
                        data: groupQuestionsMapping["TALENT DIVERSITY"],
                        title: talentDiversityData.title,
                      });
                    }}
                  >
                    See questions
                  </div>
                ) : (
                  ""
                )}
                {talentDiversityData ? (
                  <CurrentPiechart
                    labels={talentDiversityData.labels}
                    values={talentDiversityData.values}
                    title={talentDiversityData.title}
                    colors={talentDiversityData.colors}
                    kpis={talentDiversityData.kpis}
                    gaugeValue={talentDiversityData.gaugeValue}
                    gaugeColor={talentDiversityData.gaugeColor}
                    gaugeThreshhold={!isExternal ? scoresThreshold["TALENT DIVERSITY"]:null}
                  />
                ):  <CurrentPiechart
                gaugeValue={0}
                gaugeColor="white"
                title="Talent Diversity"
                isEmptyState
              /> }
              </div>
            </Col>
          </Row>

          <Row className="mt-1 mm_chart_container">
            <Col>
              <div>
                {groupQuestionsMapping["WORKPLACE INCLUSIVITY"] &&
                groupQuestionsMapping["WORKPLACE INCLUSIVITY"].length ? (
                  <div
                    className="link-text cursor-pointer see-questions-div"
                    onClick={() => {
                      setGroupWiseQuestions({
                        display: true,
                        data: groupQuestionsMapping["WORKPLACE INCLUSIVITY"],
                        title: workplaceInclusivityData.title,
                      });
                    }}
                  >
                    See questions
                  </div>
                ) : (
                  ""
                )}
                {workplaceInclusivityData ? (
                  <CurrentPiechart
                    labels={workplaceInclusivityData.labels}
                    values={workplaceInclusivityData.values}
                    title={workplaceInclusivityData.title}
                    colors={workplaceInclusivityData.colors}
                    kpis={workplaceInclusivityData.kpis}
                    gaugeValue={workplaceInclusivityData.gaugeValue}
                    gaugeColor={workplaceInclusivityData.gaugeColor}
                    gaugeThreshhold={!isExternal ? scoresThreshold["WORKPLACE INCLUSIVITY"]:null}
                  />
                ): <CurrentPiechart
                gaugeValue={0}
                gaugeColor="white"
                title="Workplace Inclusivity"
                isEmptyState
              />}
              </div>
            </Col>

            <Col>
              <div>
                {groupQuestionsMapping["ENGAGEMENT & COMMUNICATION"] &&
                groupQuestionsMapping["ENGAGEMENT & COMMUNICATION"].length ? (
                  <div
                    className="link-text cursor-pointer see-questions-div"
                    onClick={() => {
                      setGroupWiseQuestions({
                        display: true,
                        data:
                          groupQuestionsMapping["ENGAGEMENT & COMMUNICATION"],
                        title: engagementAndCommunicationData.title,
                      });
                    }}
                  >
                    See questions
                  </div>
                ) : (
                  ""
                )}
                {engagementAndCommunicationData ? (
                  <CurrentPiechart
                    labels={engagementAndCommunicationData.labels}
                    values={engagementAndCommunicationData.values}
                    title={engagementAndCommunicationData.title}
                    colors={engagementAndCommunicationData.colors}
                    kpis={engagementAndCommunicationData.kpis}
                    gaugeValue={engagementAndCommunicationData.gaugeValue}
                    gaugeColor={engagementAndCommunicationData.gaugeColor}
                    gaugeThreshhold={
                      !isExternal ?  scoresThreshold["ENGAGEMENT & COMMUNICATION"] :null
                    }
                  />
                ) :
                <CurrentPiechart
                gaugeValue={0}
                gaugeColor="white"
                title="Engagement & Communication"
                isEmptyState
              />
                }
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  };

  return (
    <div className="p-3">
      <div className="d-flex px-0 align-items-center mm-snapshot-top-container">
        <div className="d-flex mm-snapshot-date-container">
          <Alert
            color={selectedDate ? "success" : "info"}
            className="ml-0"
            style={{
              // width: "60%",
              backgroundColor: "#a3bfe940",
              color: "#172b4d",
              borderColor: "#a3bfe940",
              marginBottom: "0px",
              padding: "0.35em 0.5em",
            }}
          >
            <div className="d-flex align-items-center">
              {selectedDate ? (
                <b> Workplace Assessment analytics for </b>
              ) : (
                <b> Please first select a date to see analytics </b>
              )}{" "}
              <div style={{ flex: 1 }}>
                <ReactDatePicker
                  id="selectFileDate"
                  placeholderText="Enter date"
                  className="input-custom-date form-control ml-2"
                  showYearDropdown
                  onChange={(d) => {
                    handleDateChange(d);
                  }}
                  selected={selectedDate ? moment(selectedDate) : null}
                />

                <IoCalendarClear
                  size={22}
                  className="calendar-icon"
                  style={{
                    position: "absolute",
                    right: "30px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    if (document.getElementById("selectFileDate")) {
                      document.getElementById("selectFileDate").click();
                    }
                  }}
                />
              </div>
            </div>
          </Alert>
        </div>

        {reportDoc && reportDoc.selectedBenchmarkId ? (
          <Button
            onClick={() => setBenchmarkModalOpen(true)}
            className="select-benchmark-button ml-4"
            id="benchmark_select_popover"
            disabled={isExternal}
          >
            {benchmarksList.find(
              (x) => x._id == reportDoc.selectedBenchmarkId
            )
              ? `${
                benchmarksList.find(
                    (x) => x._id == reportDoc.selectedBenchmarkId
                  ).industry
                } (benchmark)`
              : "Select benchmark"}
            <FaCaretDown color="white" className="ml-2" />
          </Button>
        ) : (
          <Button
            onClick={() => setBenchmarkModalOpen(true)}
            className="select-benchmark-button ml-4"
            id="benchmark_select_popover"
            disabled={isExternal}
          >
            Select benchmark <FaCaretDown color="white" className="ml-2" />
          </Button>
        )}

        {isExternal ? (
          <span
            className="link-text ml-2"
            onClick={() => {
              window.open("https://www.ouroffice.io/engage-now","new")
            }}
          >
            (upgrade)
          </span>
        ) : (
          ""
        )}

        {isExternal && externalUserLoginDetails &&  externalUserLoginDetails.email && (
          <UpgradeModal
            open={upgradeModalOpen}
            onClose={() => {
              setUpgradeModalOpen(false);
            }}
            userDetails={externalUserLoginDetails}
          />
        )}

        {strategyAndCommitmentData && (
          <div className="mm-snapshot-menu-container">
            <UncontrolledDropdown className="ml-2">
              <DropdownToggle caret className="button-8">
                Actions <IoMenu size={"22px"} />
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleDownload("snapshot")}>
                  Download Snapshot
                </DropdownItem>
                {/* {totalScore > 25 ? (
              <DropdownItem onClick={() => handleDownload("badge")}>
                Download Badge
              </DropdownItem>
            ) : (
              ""
            )} */}
              </DropdownMenu>
            </UncontrolledDropdown>
          </div>
        )}
      </div>
      <div className="mm-snapshot-last-update-itm">
        {lastSubmittedToShow ? (
          <span>
            Last updated: {moment(lastSubmittedToShow).format("MM/DD/YYYY")}
          </span>
        ) : (
          ""
        )}
      </div>

      <div
        style={{ width: "400px", textAlign: "center", display: "none" }}
        ref={badgeRef}
      >
        <img src={availableBadge} alt="" />
      </div>

      {groupWiseQuestions && groupWiseQuestions.display ? (
        <Modal isOpen={groupWiseQuestions.display}>
          <ModalHeader
            toggle={() =>
              setGroupWiseQuestions({
                display: false,
                data: [],
                title: "",
              })
            }
          >
            {groupWiseQuestions.title}
          </ModalHeader>
          <ModalBody>
            <div style={{ maxHeight: "500px", overflowY: "auto" }}>
              <Table>
                <thead>
                  <tr>
                    <th>Question</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {groupWiseQuestions.data &&
                    groupWiseQuestions.data.map((item) => {
                      return item.kpiInputs.map((x) => (
                        <tr>
                          <td>{x.text}</td>
                          <td>
                            {x.value
                              ? x.value
                                  .replace("yes", "Yes")
                                  .replace("no", "No")
                              : "NA"}
                          </td>
                        </tr>
                      ));
                    })}
                </tbody>
              </Table>
            </div>
          </ModalBody>
        </Modal>
      ) : (
        ""
      )}

      {selectedDate || isExternal ? (
        <div>
          <div style={{ display: "none" }}>
            <div ref={snapShotRef} id="jspdf_export_snapshot">
              {scoreLoaded ? (
                <div>
                  {!isExternal ? (
                    <div style={{ marginTop: "2.5em" }}>
                      <div className="">
                        <div className="d-flex justify-content-center align-items-center">
                          <h4>{user.profile.organizationId.name}</h4>{" "}
                          <div
                            className="text-center ml-2"
                            style={{ fontSize: "13px" }}
                          >
                            ({moment(selectedDate).format("MMMM DD, YYYY")})
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}

                  {commonUi()}
                </div>
              ) : (
                <div className="text-center">Loading scores....</div>
              )}
            </div>
          </div>

          <div>
            {scoreLoaded ? (
              <div>
                <div style={{ marginTop: "2.5em" }}>{commonUi()}</div>
              </div>
            ) : (
              <div className="text-center">Loading scores....</div>
            )}
          </div>
        </div>
      ) : (
        <div>
          {scoreLoaded && reportDoc == null  ? (
            <div className="disabled mx-5 pr-5">
              {/* <h4>Your organization</h4> */}
              <MaturityModelProgressBar
                titles={["Aware", "Focused", "Progressive", "World Class"]}
                value={0}
              />

              <div className="my-5">
                <Row>
                  
                  <Col>
                    <CurrentPiechart
                      gaugeValue={0}
                      gaugeColor="white"
                      title="Strategy & Commitment"
                    />
                  </Col>

                  <Col>
                    <CurrentPiechart
                      gaugeValue={0}
                      gaugeColor="white"
                      title="Talent Diversity"
                    />
                  </Col>
                </Row>

                <Row className="mt-3">
                  <Col>
                    <CurrentPiechart
                      gaugeValue={0}
                      gaugeColor="white"
                      title="Workplace Inclusivity"
                    />
                  </Col>

                  <Col>
                    <CurrentPiechart
                      gaugeValue={0}
                      gaugeColor="white"
                      title="Engagement & Communication"
                    />
                  </Col>
                </Row>
              </div>
            </div>
          ) : (
            <div className="text-center">Loading scores....</div>
          )}
        </div>
      )}

      <Popover
        target="benchmark_select_popover"
        placement="bottom"
        isOpen={benchmarkModalOpen}
        toggle={() => setBenchmarkModalOpen(false)}
      >
        <PopoverBody>
          <div className="m-3 mm-current-container">
            <div
            // style={{ width: "60%" }}
            >
              <Label>Select industry benchmark</Label>
              {/* {selectedIndustry && benchmarksList.find(x => x._id.toString() == selectedIndustry.toString())? benchmarksList.find(x => x._id.toString() == selectedIndustry.toString()).industry:""} */}
              <Select
                options={industryOptions.filter(x => !x.isDeleted)}
                value={selectedIndustry && {label: benchmarksList.find(x => x._id.toString() == selectedIndustry.toString())? benchmarksList.find(x => x._id.toString() == selectedIndustry.toString()).industry:""}}
                onChange={(e) => {
                  handleIndustryChange(e);
                }}
              />
            </div>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    user: state.user,
    selectedDate: state.maturityModel.selectedDate,
    isExternalUserLoggedIn: state.maturityModel.isExternalUserLoggedIn,
    externalUserLoginDetails: state.maturityModel.externalUserLoginDetails,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    updateSelectedDate: (data) =>
      dispatch(actionCreators.updateSelectedDate(data)),
    updateExternalUserLogin: (data) =>
      dispatch(actionCreators.updateExternalUserLogin(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CurrentTab);
